<template>
    <LayoutBase>
        <div class="">
            <header id="header">
                <div class="container">
                    <div class="">
                        <h1 class="h1">People</h1>
                    </div>
                    <div class="actions">
                        <contact-list-modal v-if="is_admin" :contactList="contactList"></contact-list-modal>
                        <contact-modal v-if="is_admin" :externalContact="externalContact" :listData="listData" @update-list="getUsers"></contact-modal>

                        <a v-on:click.stop.prevent="openEditListModal(list)" class="btn btn-small" v-if="is_admin && list !== ''">Edit contact list</a>

                        <a href="#" class="btn btn-small btn-primary" v-on:click.stop.prevent="openNewContactModal()" v-if="is_admin && list !== ''">Add a contact</a>
                    </div>
                </div>
                <nav class="container">
                    <ul>
                        <li>
                            <router-link :to="{ name: 'people' }">All</router-link>
                        </li>
                        <li v-for="list in team.contact_lists">
                            <router-link :to="{ name: 'people-list', params: { list: list.id }}">{{ list.name }}</router-link>
                        </li>
                        <li v-if="is_admin">
                            <a v-on:click.stop.prevent="openNewModal()" href="#" class="add">
                                <i class="icon ion-md-add"></i> New contact list
                            </a>
                        </li>
                    </ul>
                </nav>
            </header>
            <div class="container">
                <div class="grid">
                    <div class="col-md-4" v-for="user in users">
                        <div class="card card--person">
                            <div class="header">
                                <avatar :user="user" :key="user.id" v-if="list === ''"></avatar>

                                <router-link :to="{ name: 'view-profile', params: { user: user.id }}" class="featured-image" v-if="list === ''">
                                    <h2>{{ user.name }}</h2>
                                </router-link>

                                <h2 v-if="list !== ''">{{ user.name }}</h2>

                                <button class="btn btn-tiny" v-if="list !== '' && is_admin" v-on:click.stop.prevent="openEditModal(user.id)">
                                    <i class="icon ion-md-create"></i>
                                </button>
                            </div>

                            <span class="job-title" v-if="internal">{{ user.job_title }}</span>

                            <span class="meta" v-if="internal">
                                <span class="meta__key">Phone:</span> <a :href="'tel:' + user.phone_office" class="meta__value">{{ user.phone_office }}</a>
                            </span>

                            <span class="meta" v-if="internal">
                                <span class="meta__key">Mobile:</span> <a :href="'tel:' + user.phone_mobile" class="meta__value">{{ user.phone_mobile }}</a>
                            </span>

                            <span class="meta" v-if="internal && team.hide_email === 0">
                                <span class="meta__key">Email:</span> <a :href="'mailto:' + user.email" class="meta__value">{{ user.email }}</a>
                            </span>

                            <span class="meta" v-if="user.fields" v-for="field in listData.fields">
                                <span class="meta__key">{{ field.label }}:</span>
                                <a :href="user.fields[field.label]" class="meta__value" v-if="field.type == 'link'">
                                    {{ user.fields[field.label] }}
                                </a>

                                <a :href="'mailto:' + user.fields[field.label]" class="meta__value" v-if="field.type == 'email' && team.hide_email === 0">
                                    {{ user.fields[field.label] }}
                                </a>

                                <a :href="'tel:' + user.fields[field.label]" class="meta__value" v-if="field.type == 'tel'">
                                    {{ user.fields[field.label] }}
                                </a>

                                <div v-if="field.type == 'text'" class="meta__value">
                                    {{ user.fields[field.label] }}
                                </div>

                                <div v-if="field.type == 'yes_no'" class="meta__value">
                                    {{ user.fields[field.label] ? "Yes" : "No"}}
                                </div>
                            </span>
                        </div>
                    </div>
                </div>
                <vuetable-pagination
                    ref="pagination"
                    @vuetable-pagination:change-page="onChangePage"
                ></vuetable-pagination>
            </div>
        </div>
    </LayoutBase>
</template>

<script>
    import MicroModal from 'micromodal';
    import qs from 'qs';
    import LayoutBase from '../../layouts/LayoutBase';
    import VuetablePagination from 'vuetable-2/src/components/VuetablePagination';
    import PaginationMixin from 'vuetable-2/src/components/VuetablePaginationMixin';
    import { mapState, mapGetters } from 'vuex';

    export default {
        components: {
            LayoutBase,
            VuetablePagination
        },
        data () {
            return {
                is_admin: window.user_can.admin,
                list: "",
                users: [],
                listData: [],
                listFields: {},
                externalContact: {
                    name: "",
                    fields: {}
                },
                contactList: {
                    name: "",
                    fields: []
                },
                page: 0,
                internal: true
            }
        },
        computed: {
            ...mapState({
                team: state => state.auth.team,
            })
        },
        created() {
            if( typeof this.$route.params.list !== 'undefined'){
                this.list = this.$route.params.list;
                this.internal = false;
            }else{
                this.list = "";
                this.internal = true;
            }

            this.getUsers();
            this.getList();
        },
        mounted(){
            MicroModal.init();
        },
        methods: {
            onChangePage(page) {
                this.page = page;
                this.getUsers(page);
                this.getList();
            },
            getUsers(page = 0) {
                var queryString = qs.stringify({
                    page: page,
                    list: this.list
                });

                axios.get('/api/people?' + queryString).then((response) => {
                    this.users = response.data.data;
                    if(typeof this.$refs.pagination !== "undefined"){
                        this.$refs.pagination.setPaginationData(response.data);
                    }
                }, (response) => {
                    this.error = response;
                });
            },
            getList(){
                if(this.list !== ""){
                    axios.get('/api/people/contact-list/' + this.list).then((response) => {
                        this.listData = response.data;
                        this.listData.fields.forEach(field => {
                            this.listFields[field.label] = field.type;
                        });

                    }, (response) => {
                        this.error = response;
                    });
                }else{
                    this.listData = [];
                }
            },
            openEditListModal(list){
                MicroModal.show("contact-list-modal");
                this.contactList = this.listData;

                // axios.get('/api/people/contact-list/' + list).then((response) => {
                //     this.contactList = response.data;
                // }, (response) => {
                //     this.error = response;
                // });
            },
            openNewModal(){
                this.contactList = {
                    name : "",
                    fields: []
                };
                MicroModal.show("contact-list-modal");
            },
            openNewContactModal(){
                this.externalContact = {
                    name: "",
                    fields: {}
                };
                MicroModal.show("contact-modal");
                this.getList();

                this.newContactList = {
                    name : "",
                    fields: []
                };
            },
            // addContactListField(){
            //     this.newContactList.fields.push({
            //         'label' : "",
            //         'type' : "text"
            //     });
            // },
            // addEditContactList(listID) {
            //     if(listID === null){
            //         axios.post('/api/people/contact-list', this.newContactList).then((response) => {
            //             MicroModal.close("contact-list-modal");
            //             this.$store.dispatch('auth/fetchTeam');
            //         }, (response) => {
            //             this.error = response;
            //         });
            //     }else{
            //         axios.put('/api/people/contact-list/' + listID, this.newContactList).then((response) => {
            //             MicroModal.close("contact-list-modal");
            //             this.$store.dispatch('auth/fetchTeam');
            //         }, (response) => {
            //             this.error = response;
            //         });
            //     }
            // },
            // addExternalContact() {
            //     this.externalContact = {
            //         name: "",
            //         fields: {}
            //     };

            //     axios.post('/api/people/contact-list/' + this.list + '/contact', this.externalContact).then((response) => {
            //         this.getUsers(this.page);
            //         MicroModal.close("contact-modal");
            //     }, (response) => {
            //         this.error = response;
            //     });
            // },
            // editExternalContact(externalContactID){
            //     axios.put('/api/people/contact-list/' + this.list + '/contact/' + externalContactID, this.externalContact).then((response) => {
            //         this.getUsers(this.page);
            //         MicroModal.close("contact-modal");
            //     }, (response) => {
            //         this.error = response;
            //     });
            // },
            openEditModal(externalContactID){
                this.externalContact = {
                    name: "",
                    fields: {}
                };

                axios.get('/api/people/contact-list/' + this.list + '/contact/' + externalContactID).then((response) => {
                    this.externalContact = response.data;
                    MicroModal.show("contact-modal");
                }, (response) => {
                    this.error = response;
                });
            },
            deleteExternalContact(externalContactID){
                axios.delete('/api/people/contact-list/' + this.list + '/contact/' + externalContactID).then((response) => {
                    this.getUsers(this.page);
                    MicroModal.close("contact-modal");
                }, (response) => {
                    this.error = response;
                });
            }
        },
        beforeRouteUpdate (to, from, next) {
            if( typeof to.params.list !== 'undefined'){
                this.list = to.params.list;
                this.internal = false;
            }else{
                this.list = "";
                this.internal = true;
            }

            this.getUsers(0);
            this.getList();
            next();
        },
        beforeRouteLeave (to, from, next) {
            if( typeof to.params.list !== 'undefined'){
                this.list = to.params.list;
                this.internal = false;
            }else{
                this.list = "";
                this.internal = true;
            }

            this.getUsers(0);
            this.getList();
            next();
        }
    }
</script>
